import React from 'react'
import CalculatorLabelAndTextDisplay from 'components/CalculatorLabelAndTextDisplay'
import injectSheet from 'react-jss'
import style from './style'

function focalTextDisplay(min, max) {
  return max ? `${min} - ${max}mm` : `${min}mm`
}

const ModelFocalLengthDisplay = ({ focalMin, focalMax, classes }) => {
  return (
    <CalculatorLabelAndTextDisplay labelText='Focal Length'>
      <div className={classes.container}>
        { focalTextDisplay(focalMin, focalMax) }
        {
          !focalMax &&
            <span className={classes.fixed}>
              fixed
            </span>
        }
      </div>
    </CalculatorLabelAndTextDisplay>
  )
}

export default injectSheet(style)(ModelFocalLengthDisplay)



// WEBPACK FOOTER //
// ./src/components/FocalLengthContainer/ModelFocalLengthDisplay/index.js